import { gql } from '@apollo/client'

export const mediaUploadFieldsFragment = gql`
  fragment MediaUploadFields on MediaUpload {
    id
    filePath
    type
    transformationStatus
    caption
    credit
  }
`
